import { UseFormRegister } from "react-hook-form";
import { Task } from "../../../types/task";

interface Props {
    task: Task;
    register: UseFormRegister<Task>;
}

export function Description({ task, register }: Props) {

    const descripcionLength =  task.descripcion != undefined ? task.descripcion.length : 0;

    return (
        <div className="mb-3 ">
            <p className="font-semibold text-lg">Descripción</p>
            {descripcionLength > 0 || task.estatus != "Terminada"
            ?
            <textarea 
            {...register("descripcion")}
                disabled={task.estatus == "Terminada"}
                placeholder="Agregar descripcion"
                className="
                    bg-transparent disabled:bg-white resize-none h-[100px] w-full focus:outline-none focus:ring-2 
                    focus:ring-slate-600 border-2 border-transparent rounded font-semibold text-sm"></textarea>
            :
            <p className="h-[100px] italic text-sm">Sin descripción</p>
            }
        </div>
    );
}